<template>
    <footer class="container footer-wrap" :class="{dark:isDark}">
        <div class="footer">
            <div class="footer-entry">
                <div class="category">
                    <h4 class="title">دسته بندی ها</h4>
                    <div class="category-items">
                        <div class="right category-item">
                            <a v-for="(item,index) in category.right"
                               :key="index"
                               :href="item.href"
                               @click.prevent="$router.push(item.href)"
                            >{{ item.title }}</a>
                        </div>
                        <div class="left category-item">
                            <a v-for="(item, index) in category.left"
                               :key="index"
                               :href="item.href"
                               @click.prevent="$router.push(item.href)"
                            >{{ item.title }}</a>
                        </div>
                    </div>
                </div>
                <div class="access-link">
                    <h4 class="title">دسترسی آسان</h4>
                    <div>
                        <a v-for="(item, index) in accessLink" :key="index" @click.prevent="$router.push(item.href)" :href="item.href">{{
                                item.title
                            }}</a>
                    </div>
                </div>
                <div class="contact">
                    <h4 class="title">ارتباط با سیزپک</h4>
                    <div class="contact-items">
                        <p>تهران، جاده مخصوص، کیلومتر 20 خیابان نفت پارس، پلاک 24</p>
                        <p>تلفن : 021 - 44637879</p>
                        <p>فکس : 021 - 44636390</p>
                    </div>
                </div>
                <div class="logo">
                    <img :src="getBackground" alt="">
                    <p class="content">سیزپک اولین سامانه استعلام قیمت بسته بندی</p>
                </div>
                <div class="meta">
                    <div class="certificates">
                        <template v-for="item in certificates" :key="item.path">
                            <div>
                                <a class="aspect11" :href="item.href">
                                    <img :src="item.src" alt="">
                                </a>
                            </div>
                        </template>
                    </div>
                    <div class="social">
                    </div>
                    <p class="content">سیزپک را در شبکه های اجتماعی دنبال کنید</p>
                    <div>
                        <a v-for="item in social" :key="item.src" :href="item.href" v-html="item.src"/>
                    </div>
                </div>
            </div>
        </div>
    </footer>

</template>

<script>

export default {
    name: "TheFooter",
    props: ['isDark'],
    data() {
        return {
            certificates: [
                {src: require("@/assets/images/samandehi.png"), href: "#"},
                {src: require("@/assets/images/namad.png"), href: "#"},
                {src: require("@/assets/images/unnamed.png"), href: "#"},
            ],
            social: [{
                src: `<svg width="30" height="30" viewBox="0 0 30 30" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z"
                                          fill="#3B5998"/>
                                    <path d="M18.7718 15.5873H16.0952V25.393H12.04V15.5873H10.1113V12.1412H12.04V9.91119C12.04 8.31648 12.7975 5.81934 16.1313 5.81934L19.1352 5.8319V9.17694H16.9557C16.5982 9.17694 16.0955 9.35556 16.0955 10.1163V12.1444H19.1261L18.7718 15.5873Z"
                                          fill="white"/>
                                </svg>`,
                href: "#"
            }, {
                src: `<svg width="30" height="30" viewBox="0 0 30 30" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path d="M14.9999 0C23.2837 0 30 6.71625 30 15.0001C30 23.2839 23.2838 30 15.0001 30C6.71635 30 0 23.2838 0 15.0001C0 6.71635 6.71532 0 14.9999 0Z"
                                          fill="#3F729B"/>
                                    <path d="M20.1768 6.56055H9.82213C8.02307 6.56055 6.56055 8.02399 6.56055 9.82213V20.1778C6.56055 21.9768 8.02399 23.4394 9.82213 23.4394H20.1778C21.9768 23.4394 23.4394 21.9759 23.4394 20.1778V9.82213C23.4393 8.02399 21.9758 6.56055 20.1768 6.56055ZM21.2043 8.44776L21.5737 8.44683V11.2481L18.7518 11.2575L18.7425 8.4562L21.2043 8.44776ZM15 12.1761C17.3409 12.1761 17.8237 14.3736 17.8237 15.0008C17.8237 16.5561 16.5562 17.8236 15 17.8236C13.4428 17.8236 12.1762 16.5561 12.1762 15.0008C12.1752 14.3736 12.659 12.1761 15 12.1761ZM21.5896 19.9734C21.5896 20.865 20.865 21.5906 19.9715 21.5906H9.99647C9.10394 21.5906 8.37835 20.8659 8.37835 19.9734V13.1212H10.7221C10.5046 13.6565 10.3817 14.3877 10.3817 15.0009C10.3817 17.5453 12.4517 19.6162 14.9971 19.6162C17.5424 19.6162 19.6114 17.5453 19.6114 15.0009C19.6114 14.3877 19.4885 13.6565 19.272 13.1212H21.5876V19.9734H21.5896Z"
                                          fill="white"/>
                                </svg>`,
                href: "#"
            }, {
                src: `<svg width="30" height="30" viewBox="0 0 30 30" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z"
                                          fill="#007AB9"/>
                                    <path d="M23.9629 16.2069V22.391H20.3775V16.6213C20.3775 15.1726 19.8599 14.1833 18.5617 14.1833C17.571 14.1833 16.9825 14.8493 16.7226 15.4943C16.6282 15.7248 16.6039 16.0448 16.6039 16.3681V22.3908H13.0182C13.0182 22.3908 13.0663 12.6188 13.0182 11.6072H16.6041V13.1354C16.5969 13.1474 16.5867 13.1592 16.5803 13.1707H16.6041V13.1354C17.0806 12.4022 17.9304 11.354 19.8355 11.354C22.1944 11.354 23.9629 12.8952 23.9629 16.2069ZM9.26723 6.40918C8.04072 6.40918 7.23828 7.21429 7.23828 8.27208C7.23828 9.30741 8.01745 10.1358 9.22017 10.1358H9.24343C10.494 10.1358 11.2716 9.30741 11.2716 8.27208C11.2478 7.21429 10.494 6.40918 9.26723 6.40918ZM7.45139 22.391H11.0357V11.6072H7.45139V22.391Z"
                                          fill="#F1F2F2"/>
                                </svg>`,
                href: "#"
            }, {
                src: `<svg width="30" height="30" viewBox="0 0 30 30" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0 15.0002C0 21.1424 3.6935 26.4191 8.97875 28.7391C8.93657 27.6916 8.97125 26.4342 9.23985 25.2946C9.52824 24.0769 11.1699 17.121 11.1699 17.121C11.1699 17.121 10.6907 16.1633 10.6907 14.7478C10.6907 12.5248 11.9791 10.8646 13.5836 10.8646C14.948 10.8646 15.6072 11.8894 15.6072 13.1166C15.6072 14.4882 14.7324 16.5398 14.2825 18.44C13.9067 20.0311 15.0803 21.329 16.6501 21.329C19.4921 21.329 21.4062 17.6787 21.4062 13.3538C21.4062 10.0662 19.192 7.60556 15.1646 7.60556C10.6145 7.60556 7.77981 10.9988 7.77981 14.7891C7.77981 16.096 8.16512 17.0176 8.76864 17.7312C9.04614 18.059 9.08469 18.1908 8.98426 18.5672C8.91231 18.8432 8.74708 19.5077 8.67864 19.771C8.57879 20.1509 8.27094 20.2867 7.92759 20.1464C5.83181 19.2909 4.85576 16.9958 4.85576 14.4158C4.85576 10.1547 8.44942 5.04537 15.5763 5.04537C21.3032 5.04537 25.0725 9.18957 25.0725 13.6381C25.0725 19.5224 21.8011 23.9185 16.9789 23.9185C15.3595 23.9185 13.8362 23.0431 13.3143 22.0487C13.3143 22.0487 12.4435 25.5048 12.2591 26.1722C11.941 27.3287 11.3185 28.4847 10.7493 29.3856C12.1295 29.7937 13.5613 30.0008 15.0005 30.0007C23.2838 30.0007 30 23.2848 30 15.0002C30 6.71587 23.2838 0 15.0005 0C6.71646 0 0 6.71587 0 15.0002Z"
                                          fill="#CB1F27"/>
                                </svg>`,
                href: "#"
            }, {
                src: `<svg width="30" height="30" viewBox="0 0 30 30" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="15" cy="15" r="15" fill="#43B7EA"/>
                                    <path d="M25 9.73166C24.3377 10.0254 23.626 10.2238 22.879 10.3131C23.6415 9.85611 24.227 9.13238 24.5027 8.27007C23.7778 8.70023 22.9847 9.00331 22.1577 9.1662C21.484 8.44852 20.5243 8 19.4621 8C17.4226 8 15.7691 9.65347 15.7691 11.6928C15.7691 11.9823 15.8018 12.2641 15.8647 12.5345C12.7956 12.3804 10.0745 10.9102 8.25304 8.67598C7.93523 9.2214 7.75312 9.85583 7.75312 10.5325C7.75312 11.8138 8.40513 12.944 9.39597 13.6063C8.80953 13.5879 8.23599 13.4295 7.72323 13.1443C7.72302 13.1598 7.72302 13.1753 7.72302 13.1908C7.72302 14.9801 8.99596 16.4727 10.6853 16.8119C10.1415 16.9598 9.57107 16.9815 9.01762 16.8752C9.48752 18.3423 10.8514 19.41 12.4673 19.4398C11.2034 20.4303 9.61105 21.0207 7.88095 21.0207C7.58282 21.0207 7.28891 21.0032 7 20.9691C8.63427 22.0169 10.5754 22.6282 12.6609 22.6282C19.4535 22.6282 23.1679 17.0011 23.1679 12.1211C23.1679 11.9609 23.1644 11.8017 23.1573 11.6433C23.8802 11.1207 24.5042 10.4733 25 9.73166Z"
                                          fill="white"/>
                                </svg>`,
                href: "#"
            }, {
                src: `<svg width="30" height="30" viewBox="0 0 30 30" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="15" cy="15" r="15" fill="#4FB417"/>
                                    <path d="M21.4005 7.64849C19.7329 5.93191 17.4278 5 15.0735 5C10.0709 5 6.04908 9.07082 6.09808 14.0245C6.09808 15.594 6.5395 17.1144 7.27524 18.4877L6 23.1471L10.7575 21.9209C12.0817 22.6567 13.5531 23 15.0245 23C19.9782 23 24 18.9291 24 13.9755C24 11.5722 23.0681 9.31607 21.4006 7.64849H21.4005ZM15.0735 21.4796C13.7493 21.4796 12.4251 21.1363 11.297 20.4497L11.0027 20.3025L8.15807 21.0382L8.89374 18.2426L8.69757 17.9483C6.5395 14.466 7.56949 9.85557 11.1008 7.6975C14.6321 5.5395 19.1934 6.56949 21.3515 10.1008C23.5095 13.6321 22.4795 18.1934 18.9483 20.3515C17.8201 21.0872 16.4469 21.4795 15.0735 21.4795V21.4796ZM19.3896 16.0355L18.8501 15.7903C18.8501 15.7903 18.0654 15.4469 17.5749 15.2017C17.5259 15.2017 17.4769 15.1526 17.4278 15.1526C17.2806 15.1526 17.1825 15.2017 17.0845 15.2508C17.0845 15.2508 17.0354 15.2998 16.3488 16.0845C16.2997 16.1826 16.2016 16.2317 16.1035 16.2317H16.0545C16.0055 16.2317 15.9074 16.1826 15.8583 16.1336L15.613 16.0355C15.0735 15.7903 14.5831 15.4959 14.1907 15.1036C14.0926 15.0055 13.9455 14.9074 13.8474 14.8094C13.5041 14.466 13.1607 14.0736 12.9155 13.6322L12.8665 13.5341C12.8175 13.485 12.8175 13.436 12.7684 13.3379C12.7684 13.2399 12.7684 13.1418 12.8175 13.0927C12.8175 13.0927 13.0136 12.8475 13.1607 12.7004C13.2589 12.6022 13.3079 12.4551 13.406 12.357C13.5041 12.2099 13.5531 12.0137 13.5041 11.8665C13.455 11.6213 12.8665 10.2971 12.7194 10.0028C12.6212 9.85564 12.5232 9.80663 12.376 9.75755H11.8365C11.7384 9.75755 11.6404 9.80663 11.5422 9.80663L11.4931 9.85564C11.3951 9.90471 11.297 10.0028 11.1989 10.0518C11.1008 10.15 11.0517 10.248 10.9536 10.3461C10.6103 10.7875 10.4141 11.327 10.4141 11.8665C10.4141 12.2589 10.5122 12.6513 10.6594 12.9946L10.7085 13.1418C11.1499 14.0736 11.7384 14.9074 12.5232 15.6431L12.7194 15.8393C12.8665 15.9864 13.0136 16.0845 13.1117 16.2316C14.1417 17.1145 15.3188 17.7521 16.643 18.0954C16.7902 18.1444 16.9864 18.1444 17.1335 18.1935H17.624C17.8692 18.1935 18.1635 18.0954 18.3597 17.9973C18.5068 17.8993 18.6049 17.8993 18.703 17.8012L18.8011 17.703C18.8992 17.6049 18.9973 17.5559 19.0954 17.4578C19.1934 17.3598 19.2915 17.2617 19.3406 17.1635C19.4387 16.9674 19.4877 16.7221 19.5368 16.4769V16.1336C19.5368 16.1336 19.4877 16.0845 19.3896 16.0355Z"
                                          fill="white"/>
                                </svg>`,
                href: "#"
            },
            ],
            category: {
                right: [
                    {title: "جعبه ها", href: "/categories/box"},
                    {title: "جعبه های لوکس", href: "/categories/box_lux"},
                    {title: "شاپینگ بگ", href: "/categories/shopping_bag"},
                    {title: "لیبل", href: "/categories/label"},
                ],
                left: [
                    {title: "کارتن لمینتی", href: "/categories/laminet_carton"},
                    {title: "کارتن", href: "/categories/carton"},
                    {title: "چاپ رول", href: "/categories/rotograver"},
                    {title: "شیت افست", href: "/categories/offset"},
                ],
            },
            accessLink: [
                {title: "گالری", href: {name:'gallery'}},
                {title: "درباره ما", href: {name:'aboutUs'}},
                {title: "تماس با ما", href: {name:'contact'}},
                {title: "سوالات متداول", href: {name:'faq'}},
            ],
            backgroundImages: [
                {type: 'light', src: require('@/assets/images/sizpack-light.png')},
                {type: 'dark', src: require('@/assets/images/sizpack.png')},
            ]
        }
    },
    computed: {
        getBackground() {
            let type = this.isDark ? 'light' : 'dark';
            let bg = this.backgroundImages.find(key => key.type === type);
            return bg.src;
        }
    }
}
</script>

<style scoped lang="scss">

.footer-wrap {
  background: white;

  &.dark {
    background: var(--secondary_color);
    border-top: 9px solid var(--primary_color);


    a {
      color: #FFFFFF;
    }

    p {
      color: #FFFFFF;
    }

    h4 {
      color: #FFFFFF;
    }
  }

}

.footer {


  .footer-entry {
    padding: 10px 5px;
    width: 100%;
    max-width: 100%;
    display: flex;
    flex-wrap: wrap;

    > div {
      flex: 1 1 auto;
      padding: 0 5px;
    }
  }


  @media screen and (min-width: 768px) {
    padding: 20px 24px;
  }
}

.title {
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  line-height: 29px;
  color: #000000;
}

.category-items {
  display: flex;

  .category-item {
    max-width: 50%;
    flex: 1 0 auto;

  }
}

.category-item, .access-link {
  a {
    display: inline-block;
    font-weight: 400;
    font-size: 11px;
    line-height: 21.01px;
    width: 100%;
    color: #000000;
    padding-bottom: 10px;
    text-decoration: none;
    cursor: pointer;
    transition: color 0.3s ease-out;
    &:hover {
      color: var(--orange_color);
    }
  }
}

.contact {
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  line-height: 21px;
  text-align: right;
}

.logo {
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  text-align: center;
  align-items: centern;

  img {
    display: inline-block;
    max-width: 190px;
    width: 100%;
  }

}

.content {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 23px;
  color: black;
}

.meta {
  display: flex;
  flex-direction: column;
}

.certificates {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 23px;


  @media screen and (min-width: 576px) {
    justify-content: flex-start;
  }

  & > div {
    border-radius: 10px;
    background: #E4E4E4;
    padding: 4px;
    margin-right: 10px;
    flex: 1 1 auto;
    width: 100%;
    max-width: 88px;
  }

  &:first-child {
    margin-right: 0;
  }


  img {
    object-fit: contain !important;
  }
}


.social {
  .content {
    margin-bottom: 10px;
  }

  a {
    margin-left: 5px;
  }
}

@media screen and (min-width: 992px) {
  .category {
    width: 100 / 12 * 3 * 1%;
  }
  .access-link {
    width: 100 / 12 * 2 * 1%;
  }
  .contact {
    width: 100 / 12 * 2 * 1%;
  }
  .logo {
    width: 100 / 12 * 2 * 1%;
  }
  .meta {
    width: 100 / 12 * 3 * 1%;
  }
}


</style>